import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ValidPages } from '../../shared/enums/valid-pages.enum';
import { UserStore } from '../stores/user.store';

// BatteryCare - This guard is used for the wildcard route to redirect the user to the appropriate "home" page based on his roles
export const DefaultRouteGuard: CanActivateFn = async () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.userInformation()) {
    await userStore.startAuthentication();
  }

  const hasPureAccess = userStore.checkUserHasAccess(ValidPages.APPLICATION);
  const hasBatteryCareAccess = userStore.checkUserHasAccess(ValidPages.BATTERY_CARE);

  if (hasPureAccess) {
    return router.parseUrl('/dashboard/open');
  }

  if (hasBatteryCareAccess) {
    return router.parseUrl('/batterycare/dashboard');
  }

  return router.parseUrl('/unauthorized');
};

